<ng-container *ngIf="product$ | async as product">
    <div class="product-documents-container">
        <div class="download-block" *ngIf="specSheetLinkToggle ? document?.fileUrl : product?.specSheetLink">
            <div class="vector-img"></div>
            <span class="download-text">{{ 'productDetails.title' | cxTranslate }}</span>
            <a [href]="specSheetLinkToggle ? document?.fileUrl : product.specSheetLink" target="_blank">{{ 'productDetails.link' | cxTranslate }}</a>
        </div>

        <div class="view-document">
            <ng-container *ngIf="loading == GenLoadingEnum.Loading; else link">
                <div class="cx-spinner">
                    <cx-spinner></cx-spinner>
                </div>
            </ng-container>
           
            <ng-template #link>
                <ng-container *ngIf="allDocuments?.length > 0">
                    <div class="file-img"></div>
                    <a class="document-link" (click)="scrollToDocuments()" routerLink="." replaceUrl queryParamsHandling="merge" fragment="DocumentsTab">{{ 'productDetails.viewAllDocument' | cxTranslate }}</a>
                </ng-container>
            </ng-template>
        </div>
    </div>
</ng-container>